import { useMutation, useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { MergeHowToAnnouncementAction } from "generated-graphql/graphql";

const MERGE_HOW_TO_STATUS = gql(`
  query MergeHowToAnnouncementStatus {
    mergeHowToAnnouncementStatus {
      shouldShow
    }
  }
`);

const RECORD_MERGE_HOW_TO_EVENT = gql(`
  mutation RecordMergeHowToAnnouncementEvent($input: RecordMergeHowToAnnouncementEventInput!) {
    recordMergeHowToAnnouncementEvent(input: $input) {
      ok
    }
  }
`);

export function useMergeHowToAnnouncement(enabled: boolean) {
  const { data, error } = useQuery(MERGE_HOW_TO_STATUS, {
    skip: !enabled,
    fetchPolicy: "network-only",
    errorPolicy: "ignore",
  });
  const [recordEvent] = useMutation(RECORD_MERGE_HOW_TO_EVENT, { errorPolicy: "ignore" });

  const shouldAutoOpen = !error && data?.mergeHowToAnnouncementStatus?.shouldShow === true;
  return {
    shouldAutoOpen,
    markShown: () =>
      recordEvent({ variables: { input: { action: MergeHowToAnnouncementAction.Shown } } }),
    markDismissed: () =>
      recordEvent({ variables: { input: { action: MergeHowToAnnouncementAction.Dismissed } } }),
  };
}
